(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["relife-shipping-policy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('relife-shipping-progress')) {
    class RelifeShippingProgress extends HTMLElement {
      static calculate(data, area = 'unknown') {
        if (Number(data.count) === 0) return { mode: 'empty' };
        if (data.requiresShipping === 'false') return { mode: 'digital' };
        if (data.country === 'US' && area === 'excluded') return { mode: 'excluded' };
        const threshold = Number(data.threshold);
        if (!threshold) return { mode: 'calculated' };
        if (data.currency !== data.policyCurrency) return { mode: 'mismatch' };
        if (data.taxesIncluded === 'true' || data.dutiesIncluded === 'true') return { mode: 'inclusive' };
        const subtotal = Number(data.subtotal);
        if (!Number.isFinite(subtotal) || subtotal < 0) return { mode: 'calculated' };
        return { mode: subtotal >= threshold ? 'met' : 'remaining', remaining: Math.max(0, threshold - subtotal), progress: Math.min(100, subtotal / threshold * 100) };
      }

      connectedCallback() {
        this.area = this.querySelector('[data-delivery-area]');
        if (this.area) {
          this.area.closest('label').hidden = false;
          try { this.area.value = sessionStorage.getItem('relife-shipping-area-US') || 'unknown'; } catch {}
          if (!this.area.value) this.area.value = 'unknown';
          this.area.addEventListener('change', () => {
            try { sessionStorage.setItem('relife-shipping-area-US', this.area.value); } catch {}
            document.querySelectorAll('relife-shipping-progress').forEach((element) => {
              if (element.area) element.area.value = this.area.value;
              element.render();
            });
          });
        }
        this.render();
      }

      render() {
        const result = RelifeShippingProgress.calculate(this.dataset, this.area?.value);
        let message = this.dataset[result.mode];
        if (result.mode === 'remaining') {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' }).format(result.remaining / 100);
          message = message.replace('[amount]', amount);
        }
        this.querySelector('[data-shipping-message]').textContent = message;
        const bar = this.querySelector('progress');
        bar.hidden = result.progress === undefined;
        if (!bar.hidden) bar.value = result.progress;
        this.dataset.state = result.mode;
      }
    }
    customElements.define('relife-shipping-progress', RelifeShippingProgress);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && document.querySelector('relife-shipping-progress')) window.location.reload();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
